import { FETCH_PAGINATED_BATCH_LOGS, FETCH_ALL_BATCH_LOGS, BATCH_LOG_QUERY } from '../../mutation-types';

export default {
  [FETCH_PAGINATED_BATCH_LOGS](state, { batchLogs, pagination }) {
    state.items = batchLogs;
    state.pagination = pagination;
  },

  [FETCH_ALL_BATCH_LOGS](state, batchLogs) {
    state.all = batchLogs;
  },

  [BATCH_LOG_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/batchLog/mutations.js